import Timeline from './timeline'
import TimelineItem from './timeline-item'

module.exports = {
  Timeline,
  TimelineItem
}



// WEBPACK FOOTER //
// ./~/.0.1.3@vux/src/components/timeline/index.js